import { map } from 'lodash-es';
import Vue from 'vue';
import * as C from '../constants';

export default {

  /**
   * Reverts the filter list to it's default state.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_STATE_RESET](state, payload) {
    Vue.set(state, 'loading', payload.loading);
    Vue.set(state, 'changed', payload.changed);
    Vue.set(state, 'list', payload.list);
    Vue.set(state, 'singleLoading', payload.singleLoading);
    Vue.set(state, 'single', payload.single);
  },

  /**
   * Sets the filter list in a pending state.
   *
   * @param state
   */
  [C.FILTER_LIST_ITEMS_PENDING](state) {
    Vue.set(state, 'list', { ...state.list, listLoading: true, error: null });
  },

  /**
   * Sets the filter list in a successful state.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_LIST_ITEMS_SUCCESS](state, payload) {
    Vue.set(state, 'list', { ...state.list, items: payload, listLoading: false, error: null });
  },

  /**
   * Sets the filter list in a failed state.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_LIST_ITEMS_FAILURE](state, payload) {
    Vue.set(state, 'list', { ...state.list, items: null, listLoading: false, error: payload });
  },

  /**
   * Updates the list of selected brands for the list of filters.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_LIST_BRANDS_SET](state, payload) {
    Vue.set(state, 'list', { ...state.list, brands: payload });
  },

  /**
   * Updates the product state for the list of filters.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_LIST_PRODUCTS_SET](state, payload) {
    Vue.set(state, 'list', { ...state.list, products: payload });
  },

  /**
   * Sets the filter list in a pending state for creation of a new filter.
   *
   * @param state
   */
  [C.FILTER_LIST_CREATE_FILTER_PENDING](state) {
    Vue.set(state, 'list', { ...state.list, createLoading: true });
  },

  /**
   * Sets the filter list in a successful state for creation of a new filter.
   *
   * @param state
   */
  [C.FILTER_LIST_CREATE_FILTER_SUCCESS](state) {
    Vue.set(state, 'list', { ...state.list, createLoading: false });
  },

  /**
   * Sets the filter list in a failed state for creation of a new filter.
   *
   * @param state
   */
  [C.FILTER_LIST_CREATE_FILTER_FAILURE](state) {
    Vue.set(state, 'list', { ...state.list, createLoading: false });
  },

  /**
   * Sets the app in a pending state for fetching a single filter.
   */
  [C.FILTER_SINGLE_GET_PENDING]() {
    // TODO: Dont need this at the moment.
  },

  /**
   * Sets the app in a successful state for fetching a single filter.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GET_SUCCESS](state, payload) {
    Vue.set(state.single, 'general', {
      ...payload,
      brands: map(payload.brands, brand => brand.id),
      suppliers: map(payload.suppliers, supplier => supplier.id),
      changed: false,
    });
  },

  /**
   * Sets the app in a successful state for fetching a single filter.
   */
  [C.FILTER_SINGLE_GET_FAILURE]() {
    // TODO: Don't think we need this at the moment
  },

  /**
   * Sets the app in a pending state for fetching facilities of a single filter.
   */
  [C.FILTER_SINGLE_FACILITIES_GET_PENDING]() {
    // TODO: Dont need this at the moment.
  },

  /**
   * Sets the app in a successful state for fetching facilities of a single filter.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_GET_SUCCESS](state, payload) {
    Vue.set(state.single, 'facilities', { ...payload, changed: false });
  },

  /**
   * Sets the app in a successful state for fetching facilities of a single filter.
   */
  [C.FILTER_SINGLE_FACILITIES_GET_FAILURE]() {
    // TODO: Don't think we need this at the moment
  },

  /**
   * Sets the app in a pending state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_UPDATE_PENDING](state) {
    Vue.set(state, 'singleLoading', true);
  },

  /**
   * Sets the app in a success state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_UPDATE_SUCCESS](state) {
    Vue.set(state, 'singleLoading', false);
  },

  /**
   * Sets the app in a failure state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_UPDATE_FAILURE](state) {
    Vue.set(state, 'singleLoading', false);
  },

  /**
   * Sets the app in a pending state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_FACILITIES_UPDATE_PENDING](state) {
    Vue.set(state, 'singleLoading', true);
  },

  /**
   * Sets the app in a success state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_FACILITIES_UPDATE_SUCCESS](state) {
    Vue.set(state, 'singleLoading', false);
  },

  /**
   * Sets the app in a failure state for updating a single filter.
   *
   * @param state
   */
  [C.FILTER_SINGLE_FACILITIES_UPDATE_FAILURE](state) {
    Vue.set(state, 'singleLoading', false);
  },

  /**
   * Sets the rules of the current filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_RULES_SET](state, payload) {
    Vue.set(state.single.general, 'rules', {
      ...state.single.general.rules,
      ...payload,
    });
  },

  /**
   * Sets the default parameters of the current filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_PARAMETERS_SET](state, payload) {
    Vue.set(state.single.general, 'parameters', {
      ...state.single.general.parameters,
      ...payload,
    });
  },

  /**
   * Sets the selected brands for the current filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_BRANDS_SET](state, payload) {
    Vue.set(state.single.general, 'brands', payload);
  },

  /**
   * Sets the selected suppliers for the current filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_SUPPLIERS_SET](state, payload) {
    Vue.set(state.single.general, 'suppliers', payload);
  },

  /**
   * Sets the name for the current filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_NAME_SET](state, payload) {
    Vue.set(state.single.general, 'name', payload);
  },

  /**
   * Sets the accommodation properties for the filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_PROPERTIES_SET](state, payload) {
    Vue.set(state.single.facilities, 'accommodationProperties', payload);
  },

  /**
   * Sets the accommodation categories for the filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_CATEGORIES_SET](state, payload) {
    Vue.set(state.single.facilities, 'accommodationCategories', payload);
  },

  /**
   * Sets the accommodation bedrooms for the filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_BEDROOMS_SET](state, payload) {
    Vue.set(state.single.facilities, 'accommodationBedrooms', payload);
  },

  /**
   * Sets the site facilities for the filter
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_SITE_FACILITIES_SET](state, payload) {
    Vue.set(state.single.facilities, 'siteFacilities', payload);
  },

  /**
   * Sets the changed status.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_GENERAL_CHANGED_SET](state, payload) {
    Vue.set(state.single.general, 'changed', payload);
  },

  /**
   * Sets the changed status.
   *
   * @param state
   * @param payload
   */
  [C.FILTER_SINGLE_FACILITIES_CHANGED_SET](state, payload) {
    Vue.set(state.single.facilities, 'changed', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filter/mutations.js